var map = {
	"./AtomGPT-Tomato.svg": 4111,
	"./ChatGLM-Chili.svg": 9951,
	"./ChatGPT-Potato.svg": 2908,
	"./Frame 427319136.svg": 5887,
	"./Frame-1.svg": 353,
	"./Frame-10.svg": 1361,
	"./Frame-11.svg": 4578,
	"./Frame-12.svg": 3971,
	"./Frame-13.svg": 7230,
	"./Frame-14.svg": 6324,
	"./Frame-15.svg": 7157,
	"./Frame-16.svg": 9955,
	"./Frame-17.svg": 8078,
	"./Frame-18.svg": 4854,
	"./Frame-2.svg": 2489,
	"./Frame-3.svg": 6664,
	"./Frame-4.svg": 6453,
	"./Frame-5.svg": 8152,
	"./Frame-6.svg": 2477,
	"./Frame-7.svg": 8947,
	"./Frame-8.svg": 3616,
	"./Frame-9.svg": 6608,
	"./Frame.svg": 9492,
	"./Frame_111.svg": 8086,
	"./Frame_112.svg": 959,
	"./Frame_113.svg": 2082,
	"./Frame_114.svg": 3766,
	"./Frame_115.svg": 6556,
	"./Frame_116.svg": 8342,
	"./Group_117.svg": 9099,
	"./chatglm.svg": 3013,
	"./github.svg": 2676,
	"./logo-blue.svg": 1313,
	"./mianbi-Pumpkin.svg": 2379,
	"./mianbi.svg": 1849,
	"./qianwen-Radish.svg": 3655,
	"./tongyi.svg": 6891,
	"./wenxin.svg": 596,
	"./xinghuo-Carrot.svg": 3814,
	"./xinghuo.svg": 9682,
	"./yiyan-Eggplant.svg": 289,
	"./yiyan.svg": 5438
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 240;